import { render, staticRenderFns } from "./pointRecord.vue?vue&type=template&id=753b2fd2&"
import script from "./pointRecord.vue?vue&type=script&lang=js&"
export * from "./pointRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753b2fd2')) {
      api.createRecord('753b2fd2', component.options)
    } else {
      api.reload('753b2fd2', component.options)
    }
    module.hot.accept("./pointRecord.vue?vue&type=template&id=753b2fd2&", function () {
      api.rerender('753b2fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/pointActivity/pointRecord.vue"
export default component.exports